module.exports = __webpack_public_path__ + "static/media/sinarmas.6f175f10.png";